// NOTE: remember to update vite-env.d.ts
export const APP_NAME = import.meta.env.VITE_APP_NAME
export const API_URL = import.meta.env.VITE_API_URL
export const TITLE = import.meta.env.VITE_APP_TITLE
export const DESCRIPTION = import.meta.env.VITE_APP_DESCRIPTION
export const STRIPE_PK = import.meta.env.VITE_STRIPE_PK
export const MODE = import.meta.env.MODE
export const DEBUG = ['test', 'development'].includes(MODE)
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
export const USD_DISPLAY_DECIMALS = 2
export const ENABLE_DEVTOOLS: boolean = MODE === 'development' && false
export const COMMIT_HASH = __COMMIT_HASH__
export const COBROWSE_SCRIPT = import.meta.env.VITE_COBROWSE_SCRIPT
export const TWILIO_INBROWSER_TOKEN_API_URL = import.meta.env.VITE_TWILIO_INBROWSER_TOKEN_API_URL
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY
